<template>
  <v-dialog v-if="displayLoginWindow" :model-value="displayLoginWindow" content-class="bg-background py-8 pt-lg-12 px-sm-12" scroll-strategy="none" fullscreen persistent>
    <v-row style="flex-grow: 0">
      <v-col cols="12" md="6">
        <div class="ml-auto mr-auto mr-md-0 d-flex flex-column" style="height: calc(100% + 24px); max-width: 600px; position: relative">
          <login-window></login-window>
        </div>
      </v-col>
      <v-col cols="6" class="hidden-sm-and-down pt-6" style="max-width: 600px; max-height: calc(100vh - 96px); padding-left: 100px;">
        <div class="text-right mb-12"><bubble-plan-logo style="height: 40px"></bubble-plan-logo></div>
        <img v-reload-src-on-mount src="@/img/animations/illustration-login.svg" style="max-width: 100%; max-height: calc(100% - 40px - 48px)">
      </v-col>
    </v-row>
  </v-dialog>
</template>

<script>
  import useUiModalsStore from '@/stores/ui/modals';
  import LoginWindow from './LoginWindow.vue';

  export default {
    components: {
      LoginWindow,
    },
    data() {
      return {
        uiModalsStore: useUiModalsStore(),
      };
    },
    computed: {
      displayLoginWindow() {
        return this.uiModalsStore.displayLoginWindow;
      },
    },
  };
</script>
